export const TOAST_DEFAULT_AUTO_CLOSE_TIME = 10_000;
export const TOAST_SHORT_AUTO_CLOSE_TIME = 5_000;
